import React, { Fragment, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Box,
  IconButton,
  TablePagination,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ModalLisActEco = ({
  modalOpen,
  toggleModal,
  modalTitle,
  setSearch,
  listaActEco,
  selecAct,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Manejador para el cambio de filas por página
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Datos paginados para mostrar en la tabla
  const paginatedData = listaActEco.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Dialog
      open={modalOpen}
      onClose={toggleModal}
      maxWidth="lg"
      fullWidth
      disableEscapeKeyDown
      slotProps={{
        backdrop: {
          invisible: false,
          onClick: (event) => event.stopPropagation(),
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          {modalTitle}
          <IconButton
            aria-label="close"
            onClick={toggleModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {" "}
        {/* Agrega un divisor entre el título y el contenido */}
        <Fragment>
          {/* Campo de búsqueda */}
          <Box sx={{ mb: 2 }}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Buscar..."
              onChange={(e) => setSearch(e.target.value)} // Utiliza la prop setSearch
            />
          </Box>

          <TableContainer
            component={Paper}
            sx={{ height: "calc(60vh)", overflowY: "auto" }}
          >
            <Table
              stickyHeader
              aria-label="economic activities table"
              size="small"
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "150px" }}>Código</TableCell>
                  <TableCell>Descripción</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData && paginatedData.length > 0 ? (
                  paginatedData.map((item, index) => (
                    <TableRow
                      hover
                      key={item.codigo || index}
                      onClick={() => {
                        selecAct(item);
                      }}
                      sx={{
                        cursor: "pointer",
                      }}
                    >
                      <TableCell>{item.codigo}</TableCell>
                      <TableCell>{item.descripcion}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No hay datos disponibles.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[
              5,
              10,
              25,
              { label: "Todos", value: listaActEco.length },
            ]}
            component="div"
            count={listaActEco.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Fragment>
      </DialogContent>
    </Dialog>
  );
};

export default ModalLisActEco;
